import { render } from "./AddNodeToFolder.vue?vue&type=template&id=ed885da6&ts=true"
import script from "./AddNodeToFolder.vue?vue&type=script&lang=ts"
export * from "./AddNodeToFolder.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__